import { api } from './client';
import type { Role, MemberStatus } from '@/domain/roles';

export interface Member {
  membershipId: string;
  userId: string;
  email: string;
  name: string;
  roles: Role[];
  status: MemberStatus;
  createdAt: string;
}

export async function listMembers() {
  const { data } = await api.post<{ items: Member[] }>('/members/list', {});
  return data.items;
}

export async function inviteMember(input: { email: string; name: string; roles: Role[] }) {
  const { data } = await api.post<Member>('/members/invite', input);
  return data;
}

/**
 * 改一个成员在本组织里的显示名。**只有 admin 能调**（服务端是 requireAdmin）——
 * 成员没有自助改名的入口。
 */
export async function updateMemberName(membershipId: string, name: string) {
  const { data } = await api.post<{ ok: true }>('/members/name', { membershipId, name });
  return data;
}

/** **整体覆盖**该成员的角色集合，不是增量增删。 */
export async function updateMemberRoles(membershipId: string, roles: Role[]) {
  const { data } = await api.post<{ ok: true }>('/members/roles', { membershipId, roles });
  return data;
}

export async function disableMember(membershipId: string) {
  const { data } = await api.post<{ ok: true }>('/members/disable', { membershipId });
  return data;
}

export async function enableMember(membershipId: string) {
  const { data } = await api.post<{ ok: true }>('/members/enable', { membershipId });
  return data;
}
